import React from 'react';
import { Home, ShieldCheck, AlertTriangle, Users, TrendingUp, Activity } from 'lucide-react';
export const AdminDashboard = () => {
  return <div className="space-y-8 animate-in fade-in" data-id="element-371">
      <div data-id="element-372">
        <h1 className="text-2xl font-serif font-bold text-slate-900 dark:text-white mb-1" data-id="element-373">
          System Overview
        </h1>
        <p className="text-slate-500 dark:text-slate-400" data-id="element-374">
          AMU Platform performance and metrics.
        </p>
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-375">
        {[{
        label: 'Total Listings',
        value: '1,248',
        icon: Home,
        color: 'text-blue-500 dark:text-blue-400',
        bg: 'bg-blue-50 dark:bg-blue-400/10'
      }, {
        label: 'Pending Verifications',
        value: '42',
        icon: ShieldCheck,
        color: 'text-secondary',
        bg: 'bg-secondary/10'
      }, {
        label: 'Fraud Alerts',
        value: '3',
        icon: AlertTriangle,
        color: 'text-red-500 dark:text-red-400',
        bg: 'bg-red-50 dark:bg-red-400/10'
      }, {
        label: 'Active Users',
        value: '8,492',
        icon: Users,
        color: 'text-emerald-500 dark:text-emerald-400',
        bg: 'bg-emerald-50 dark:bg-emerald-400/10'
      }, {
        label: 'Monthly Revenue',
        value: '₦42.5M',
        icon: TrendingUp,
        color: 'text-purple-500 dark:text-purple-400',
        bg: 'bg-purple-50 dark:bg-purple-400/10'
      }].map((stat, i) => {
        const Icon = stat.icon;
        return <div key={i} className="bg-white dark:bg-[#1e293b] p-6 rounded-2xl border border-slate-200 dark:border-slate-700 flex items-center gap-4 transition-colors duration-200" data-id="element-376">
              <div className={`w-14 h-14 rounded-xl flex items-center justify-center ${stat.bg} ${stat.color}`} data-id="element-377">
                <Icon size={28} data-id="element-378" />
              </div>
              <div data-id="element-379">
                <div className="text-3xl font-bold text-slate-900 dark:text-white" data-id="element-380">
                  {stat.value}
                </div>
                <div className="text-sm font-medium text-slate-500 dark:text-slate-400" data-id="element-381">
                  {stat.label}
                </div>
              </div>
            </div>;
      })}
      </div>

      <div className="grid lg:grid-cols-3 gap-8" data-id="element-382">
        {/* Main Chart Area */}
        <div className="lg:col-span-2 bg-white dark:bg-[#1e293b] rounded-2xl border border-slate-200 dark:border-slate-700 p-6 transition-colors duration-200" data-id="element-383">
          <div className="flex items-center justify-between mb-6" data-id="element-384">
            <h2 className="text-lg font-bold text-slate-900 dark:text-white" data-id="element-385">
              Revenue & Listings Growth
            </h2>
            <select className="bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-600 text-slate-700 dark:text-slate-300 text-sm rounded-lg px-3 py-1.5 outline-none" data-id="element-386">
              <option data-id="element-387">Last 30 Days</option>
              <option data-id="element-388">This Year</option>
            </select>
          </div>

          {/* Mock Chart Area */}
          <div className="h-[300px] flex items-end gap-2 pt-10" data-id="element-389">
            {[40, 55, 45, 70, 65, 85, 90, 75, 95, 100, 80, 110].map((h, i) => <div key={i} className="flex-1 flex flex-col justify-end gap-2 group" data-id="element-390">
                <div className="w-full bg-secondary/20 rounded-t-sm relative group-hover:bg-secondary/40 transition-colors" style={{
              height: `${h}%`
            }} data-id="element-391">
                  <div className="absolute -top-8 left-1/2 -translate-x-1/2 bg-slate-800 text-white text-xs py-1 px-2 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap" data-id="element-392">
                    ₦{h}00k
                  </div>
                </div>
              </div>)}
          </div>
          <div className="flex justify-between mt-4 text-xs text-slate-500" data-id="element-393">
            <span data-id="element-394">Jan</span>
            <span data-id="element-395">Feb</span>
            <span data-id="element-396">Mar</span>
            <span data-id="element-397">Apr</span>
            <span data-id="element-398">May</span>
            <span data-id="element-399">Jun</span>
            <span data-id="element-400">Jul</span>
            <span data-id="element-401">Aug</span>
            <span data-id="element-402">Sep</span>
            <span data-id="element-403">Oct</span>
            <span data-id="element-404">Nov</span>
            <span data-id="element-405">Dec</span>
          </div>
        </div>

        {/* Recent Activity */}
        <div className="bg-white dark:bg-[#1e293b] rounded-2xl border border-slate-200 dark:border-slate-700 p-6 transition-colors duration-200" data-id="element-406">
          <div className="flex items-center justify-between mb-6" data-id="element-407">
            <h2 className="text-lg font-bold text-slate-900 dark:text-white" data-id="element-408">
              Recent Activity
            </h2>
            <Activity size={18} className="text-slate-400" data-id="element-409" />
          </div>

          <div className="space-y-6" data-id="element-410">
            {[{
            title: 'New Listing Submitted',
            desc: 'Luxury Duplex in Maitama',
            time: '5 mins ago',
            type: 'info'
          }, {
            title: 'Verification Approved',
            desc: 'Property ID: #P-4920',
            time: '1 hour ago',
            type: 'success'
          }, {
            title: 'Suspicious Activity Flagged',
            desc: 'Duplicate title document detected',
            time: '2 hours ago',
            type: 'error'
          }, {
            title: 'Payment Received',
            desc: 'Tier 1 Listing Fee (₦300,000)',
            time: '3 hours ago',
            type: 'success'
          }, {
            title: 'New User Registered',
            desc: 'Premium Homes Ltd (Company)',
            time: '5 hours ago',
            type: 'info'
          }].map((activity, i) => <div key={i} className="flex gap-4" data-id="element-411">
                <div className="relative mt-1" data-id="element-412">
                  <div className={`w-3 h-3 rounded-full z-10 relative ${activity.type === 'success' ? 'bg-emerald-400 shadow-[0_0_10px_rgba(52,211,153,0.5)]' : activity.type === 'error' ? 'bg-red-400 shadow-[0_0_10px_rgba(248,113,113,0.5)]' : 'bg-blue-400 shadow-[0_0_10px_rgba(96,165,250,0.5)]'}`} data-id="element-413" />
                  {i !== 4 && <div className="absolute top-3 left-1.5 w-px h-12 bg-slate-700 -translate-x-1/2" data-id="element-414" />}
                </div>
                <div data-id="element-415">
                  <h4 className="text-sm font-bold text-slate-900 dark:text-slate-200" data-id="element-416">
                    {activity.title}
                  </h4>
                  <p className="text-xs text-slate-500 dark:text-slate-400 mt-0.5" data-id="element-417">
                    {activity.desc}
                  </p>
                  <span className="text-[10px] text-slate-400 dark:text-slate-500 mt-1 block" data-id="element-418">
                    {activity.time}
                  </span>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </div>;
};